import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './liquiditySummaryChartPreview.png';
import gridPreview from './liquiditySummaryGridPreview.png';

export const liquiditySummaryDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Liquidity Summary, available in both a chart and table view,
                compares today&apos;s actual market volume to the historical
                market average, while also showing estimates of your
                order&apos;s leaves in relation to the forecasted rest of day
                and closing auction volumes.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'liquidity-summary-chart-preview',
        },
        {
            title: 'Table',
            src: gridPreview,
            altText: 'liquidity-summary-table-preview',
        },
    ],
};
